export default __webpack_public_path__ + "static/media/Samantha_9781846168925.5010aae0.jpg";